<template>
  <div class="main">
    <div class="pic" v-if="pic">
      <div>
        <h1 v-html="title"></h1>
        <p v-html="eng"></p>
      </div>
      <img :src="pic" :alt="title" class="rellax-no" data-rellax-no="-3">
    </div>
    <div class="bread">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main{
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 0 6.4rem 0 0;
  @media screen and (max-width: module.$phone){
    padding: 0;
    overflow: visible;
  }
}
.pic{
  position: relative;
  padding: calc(100% / 16 * 4.8) 0 0;
  border-radius: 0 0 1rem 0;
  overflow: hidden;
  min-height: 30rem;
  @media screen and (max-width: module.$tab){
    padding: calc(100% / 16 * 4) 0 0;
    min-height: 26rem;
  }
  @media screen and (max-width: module.$phone){
    min-height: 16rem;
    border-radius: 0;
  }
  &:before,&:after{
    content: '';
    width: 100%;
    height: 100%;
    background: module.$normal;
    position: absolute;
    top: 0;
    left: 0;
    opacity: .12;
    z-index: 2;
  }
  &:after{
    top: auto;
    bottom: 0;
    height: 100%;
    background: linear-gradient(to top, rgba(module.$black,1), rgba(module.$black,0));
    opacity: .24;
  }
  img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1);
  }
  div{
    position: absolute;
    top: 52%;
    left: calc(50% + 3.2rem);
    z-index: 2;
    color: module.$white;
    line-height: 1.4;
    text-transform: uppercase;
    transform: translate(-50%, -50%);
    text-align: center;
    @media screen and (max-width: module.$phone){
      top: auto;
      bottom: 1.6rem;
      left: module.side2x();
      text-align: left;
      transform: translateY(0);
    }
    > * {
      opacity: 0;
    }
    p{
      font-size: 1.44rem;
      font-weight: 700;
      letter-spacing: .08rem;
      animation: upToTitle 1000ms module.$ease forwards;
      @media screen and (max-width: module.$phone){
        font-size: .88rem;
      }
    }
    h1{
      font-size: 4.4rem;
      font-weight: 700;
      letter-spacing: .24rem;
      white-space: nowrap;
      animation: upToTitle 1000ms module.$ease forwards;
      @media screen and (max-width: module.$tab){
        font-size: 3.2rem;
      }
      @media screen and (max-width: module.$phone){
        font-size: 1.72rem;
      }
    }
    @keyframes upToTitle {
      0%{
        opacity: 0;
        transform: translateY(-1.2rem);
      }
      100%{
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.bread{
  position: absolute;
  top: 8rem;
  right: 3.8rem;
  z-index: 10;
  @media screen and (max-width: module.$phone){
    position: relative;
    top: auto;
    right: auto;
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    eng: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
  }
}
</script>
